var autoCompleteHitProcessors = {};

autoCompleteHitProcessors.product = function(hit) {
    var product = {};
    product.title = hit.highlight.title ? hit.highlight.title : hit._source.title;
    product.authors = hit.highlight.authors ? hit.highlight.authors : hit._source.authors;
    product.urlFront = hit._source.urlFront;

    return product;
}

autoCompleteHitProcessors.author = function(hit) {
    var author = {};
    author.urlFront = hit._source.urlFront;
    author.description = hit.highlight.search[0] ? hit.highlight.search[0] : hit._source.description;

    return author;
}

autoCompleteHitProcessors.category = function(hit) {
    var category = {};
    category.urlFront = hit._source.urlFront;
    category.description = hit.highlight.search[0] ? hit.highlight.search[0] : hit._source.description;

    return category;
}

autoCompleteHitProcessors.faq = function(hit) {
    var faq = {};

    faq.id = hit._id;
    faq.question = hit.highlight.question ? hit.highlight.question : hit._source.question;
    faq.answer = hit.highlight.answer ? '..' + hit.highlight.answer + '..' : hit._source.answer.substring(0,50) + '..';

    return faq;
}

autoCompleteHitProcessors.publisher = function(hit) {
    var publisher = {};
    publisher.urlFront = hit._source.publisherUrl;
    publisher.description = hit._source.publisher;

    return publisher;
}